export enum AccountListColumns {
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  STATUS = 'status',
  IS_ADMIN = 'isAdmin',
  PENDING = 'pending',
  COMPANY_NAME = 'companyName'
}

// Maps UI column field names to backend API field names
export const ACCOUNT_SORT_FIELD_MAPPING: Record<string, string> = {
  [AccountListColumns.NAME]: 'accName',
  [AccountListColumns.EMAIL]: 'login',
  [AccountListColumns.STATUS]: 'state',
  [AccountListColumns.IS_ADMIN]: 'admin',
  [AccountListColumns.PENDING]: 'registerStatus',
  [AccountListColumns.COMPANY_NAME]: 'agencyId'
};

export const defaultAccountColumns = [
  AccountListColumns.NAME,
  AccountListColumns.EMAIL,
  AccountListColumns.STATUS,
  AccountListColumns.IS_ADMIN,
  AccountListColumns.PENDING
];

export const oemAccountColumns = [
  AccountListColumns.NAME,
  AccountListColumns.EMAIL,
  AccountListColumns.COMPANY_NAME,
  AccountListColumns.STATUS
];
